// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing2_landing__1KyiP"};